/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".modal.stream-settings{width:300px;right:30px;height:auto;bottom:0;left:auto;position:absolute;top:auto}[_nghost-%COMP%]     .row{margin-top:1rem;margin-bottom:1rem}.metadata-text[_ngcontent-%COMP%]{color:#fff}"];
export { styles as styles };

